import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import ServiceList from '../../components/ServiceList/ServiceList';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.png'


const ServicePage = () => {
    return (
        <Fragment>
            <div className="service-page-wrapper">
                <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
                <div className="service-page-content">
                    <ServiceList />
                </div>
                <Footer />
            </div>
            <Scrollbar />
        </Fragment>
    )
};
export default ServicePage;
